import { Routes } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';
import { drupalRouteGuard } from '@app/guards/drupal-route.guard';
import { LoginCallbackComponent } from '@app/components/login-callback/login-callback.component';

export const routes: Routes = [
  {
    path: 'auth-callback',
    pathMatch: 'full',
    component: LoginCallbackComponent,
  },
  {
    path: 'search',
    pathMatch: 'full',
    loadComponent: () =>
      import('@app/components/search-page/search-page.component').then(
        (m) => m.SearchPageComponent
      ),
    canActivate: [drupalRouteGuard],
  },
  {
    path: '**',
    children: [],
    canActivate: [drupalRouteGuard],
  },
];
export const serverRoutes: ServerRoute[] = [
  { path: 'auth-callback', renderMode: RenderMode.Client },
  { path: 'search', renderMode: RenderMode.Client },
  {
    path: '**',
    renderMode: RenderMode.Server,
  },
];
